import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GasprecioService } from '../../../gasprecio/services/gasprecio.service';
import { SharedService } from '../../../gasprecio/services/shared.service';
import { Router, Event as NavigationEvent, NavigationEnd } from '@angular/router';
import Highcharts from 'highcharts';

@Component({
  selector: 'app-chart-dif-price-quotient',
  templateUrl: './chart-dif-price-quotient.component.html',
  styleUrls: ['./chart-dif-price-quotient.component.scss']
})
export class ChartDifPriceQuotientComponent implements OnInit, OnDestroy {

  @Input() station: any = false;
  @Input() v2: any = false;
  date: any;
  days = 30;
  days$!: Subscription;
  diffSellingPrice;
  event$!: Subscription;
  fullData;
  idGroup = '60afa99655f4ee369d1df409';
  idGroup$!: Subscription;
  idStation: string;
  idStation$!: Subscription;
  importants;
  importants$: Subscription;
  limits;
  min;
  months = 12;
  months$!: Subscription;
  period = 'day';
  period$!: Subscription;
  productType = 'regular';
  productType$!: Subscription;
  quotient: any;
  reqst = 0;
  rol;
  route;
  selectedCluster;
  selectedCluster$!: Subscription;
  selectedCluster2;
  selectedCluster2$!: Subscription;
  selectedCluster3;
  selectedCluster3$!: Subscription;
  selectedCluster4;
  selectedCluster4$!: Subscription;
  showDiff = false;
  showRendichicas = false;
  tendency: any = 'avg_selling_price';
  weeks = 12;
  weeks$!: Subscription;
  zoneSelected = null;
  zoneSelected$: Subscription;
  suggestedPrice: any;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'line'
    },
    title: {
      text: `Dif Precio vs Competencia - Índice de Precios`,
      style: {
        fontSize: '0'
      }
    },
    xAxis: {
      categories: [],
      gridLineWidth: 1,
      gridLineDashStyle: 'LongDash',
      title: {
        text: 'Fecha',
        style: {
          fontSize: '0'
        }
      },
      labels: {
        style: {
          fontSize: '11px',
        },
        rotation: -60,
        y: 14
      }
    },
    yAxis: [
      {
        title: {
          text: 'Dif Precio vs Competencia',
          style: {
            fontSize: '0'
          }
        },
        labels: {
          format: '$ {value:.2f}',
          style: {
            fontSize: '11px'
          }
        },
        tickAmount: 10,
        gridLineDashStyle: 'LongDash'
      },
      {
        title: {
          text: 'Indice de Precios',
          style: {
            fontSize: '0'
          }
        },
        labels: {
          format: '{value:.3f}',
          style: {
            fontSize: '11px'
          }
        },
        opposite: true,
        tickAmount: 10,
        gridLineDashStyle: 'LongDash'
      }
    ],
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'top',
      itemDistance: 10,
      y: 1,
      padding: 1,
      itemMarginTop: 1,
      itemMarginBottom: 1,
      itemHoverStyle: {
        color: '#00E07B',
      }
    },
    tooltip: {
      split: true,
    },
    plotOptions: {
      series: {
        animation: {
          duration: 1000
        },
        marker: {
          radius: 2
        },
        lineWidth: 2
      },
      bar: {
        animation: {
          duration: 1000
        }
      }
    },
    exporting: {
      filename: `Dif Precio vs Competencia - Indice de Precios `,
      sourceWidth: 1200,
      sourceHeight: 800,
    },
    navigation: {
      buttonOptions: {
        align: 'right',
        y: -10
      }
    },
    series: []
  };

  constructor(
    private gasprecioService: GasprecioService,
    private sharedService: SharedService,
    private router: Router
  ) {
    this.event$ = this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        this.route = /[^/]*$/.exec(event.url)[0];
      }
    });
    this.rol = localStorage.getItem('rol');
    this.productType$ = this.sharedService.sharedProductTypeTotal.subscribe(productType => {
      if (this.productType !== productType) {
        this.productType = productType;
        if (this.reqst > 1) {
          this.v2 ? this.setDataV2() : this.setData();
        }
      }
    });

    this.idGroup = (this.rol === 'Dios') ? localStorage.getItem('group') || '60afa99655f4ee369d1df409' : localStorage.getItem('group');
    this.showRendichicas = this.idGroup === '615efe30b318ce63b8971986' ? true : false;
    this.idStation = localStorage.getItem('idStation');

    this.idGroup$ = sharedService.sharedGroup.subscribe((idGroup: string) => {
      if (idGroup !== this.idGroup) {
        this.idGroup = idGroup;
        this.showRendichicas = this.idGroup === '615efe30b318ce63b8971986' ? true : false;
        if (this.reqst > 1) {
          this.zoneSelected = '';
          this.getDashboardQuotientSellingPrice();
        }
      }
    });

    this.idStation$ = sharedService.sharedStation.subscribe((station: string) => {
      if(station !== this.idStation && station) {
        this.idStation = station;
        if (this.reqst > 1) {
          this.getDashboardQuotientSellingPrice();
        }
      }
    });

    this.zoneSelected$ = sharedService.sharedZoneDashboard.subscribe((zone: string) => {
      if (zone === 'Total') {
        this.zoneSelected = null;
        if (zone !== this.zoneSelected) {
          this.getDashboardQuotientSellingPrice();
        }
      } else {
        if (zone !== this.zoneSelected) {
          this.zoneSelected = zone;
          this.getDashboardQuotientSellingPrice();
        }
      }
    });

    this.period$ = this.sharedService.sharedPeriodDashboard.subscribe(period => {
      if (period !== this.period) {
        this.period = period;
        if (this.reqst > 1) {
          this.getDashboardQuotientSellingPrice();
        }
      }
    });

    this.days$ = this.sharedService.sharedDaysDashboard.subscribe(days => {
      if (days !== this.days) {
        this.days = days;
        if (this.reqst > 1) {
          this.getDashboardQuotientSellingPrice();
        }
      }
    });

    this.weeks$ = this.sharedService.sharedWeeksAgo.subscribe(weeks => {
      if (weeks !== this.weeks) {
        this.weeks = weeks;
        if (this.reqst > 1) {
          this.getDashboardQuotientSellingPrice();
        }
      }
    });

    this.months$ = this.sharedService.sharedMonthsAgo.subscribe(months => {
      if (months !== this.months) {
        this.months = months;
        if (this.reqst > 1) {
          this.getDashboardQuotientSellingPrice();
        }
      }
    });

    this.importants$ = sharedService.sharedImportants.subscribe((importants: string) => {
      if (this.importants !== importants) {
        this.importants = importants;
        if (this.reqst > 1) {
          this.getDashboardQuotientSellingPrice();
        }
      }
    });

    this.selectedCluster$ = sharedService.sharedSelectedComplementClusters.subscribe((selectedCluster: any) => {
      if (selectedCluster !== this.selectedCluster) {
        this.selectedCluster = selectedCluster;
        if (this.reqst > 1) {
          this.getDashboardQuotientSellingPrice();
        }
      }
    });

    this.selectedCluster2$ = sharedService.sharedSelectedComplementClusters2.subscribe((selectedCluster2: any) => {
      if (selectedCluster2 !== this.selectedCluster2) {
        this.selectedCluster2 = selectedCluster2;
        if (this.reqst > 1) {
          this.getDashboardQuotientSellingPrice();
        }
      }
    });

    this.selectedCluster3$ = sharedService.sharedSelectedComplementClusters3.subscribe((selectedCluster3: any) => {
      if (selectedCluster3 !== this.selectedCluster3) {
        this.selectedCluster3 = selectedCluster3;
        if (this.reqst > 1) {
          this.getDashboardQuotientSellingPrice();
        }
      }
    });

    this.selectedCluster4$ = sharedService.sharedSelectedComplementClusters4.subscribe((selectedCluster4: any) => {
      if (selectedCluster4 !== this.selectedCluster4) {
        this.selectedCluster4 = selectedCluster4;
        if (this.reqst > 1) {
          this.getDashboardQuotientSellingPrice();
        }
      }
    });
  }

  ngOnInit() {
    this.getDashboardQuotientSellingPrice();
  }

  ngOnDestroy(): void {
    this.days$.unsubscribe();
    this.event$.unsubscribe();
    this.idGroup$.unsubscribe();
    this.importants$.unsubscribe();
    this.months$.unsubscribe();
    this.period$.unsubscribe();
    this.productType$.unsubscribe();
    this.selectedCluster$.unsubscribe();
    this.selectedCluster2$.unsubscribe();
    this.selectedCluster3$.unsubscribe();
    this.selectedCluster4$.unsubscribe();
    this.weeks$.unsubscribe();
    this.zoneSelected$.unsubscribe();
  }

  getDashboardQuotientSellingPrice() {
    this.reqst = 1;
    let typeValue = 'value';
    const periodMap = {
      'day': this.days,
      'week': this.weeks,
      'month': this.months
    };
    const n = periodMap[this.period];
    typeValue = (typeof n === 'number') ? 'value' : 'date';

    if(this.importants !== undefined) {
      const url = this.station ?
        (this.v2 ? this.gasprecioService.getStationDashboardV2Data(this.idGroup, this.idStation, this.period, n) :
         this.gasprecioService.getDashboardQuotientSellingPriceStation(this.period, typeValue, n)) :
        this.gasprecioService.getDashboardQuotientSellingPrice(this.idGroup, this.zoneSelected, this.period, this.importants, typeValue, n, this.selectedCluster, this.selectedCluster2, this.selectedCluster3, this.selectedCluster4);
      url.subscribe({
        next: (data: any) => {
          if(this.v2){
            this.fullData = data;
            this.setDataV2();
          }else {
            const info = data['data'];
            this.limits = data['limits'];
            // Eliminar duplicados cuando el periodo es 'week'
            if (this.period === 'week') {
              this.quotient = this.gasprecioService.removeDuplicateWeeks(info['quotient'] || []);
              this.diffSellingPrice = this.gasprecioService.removeDuplicateWeeks(info['diff_sellling_price'] || []);
              this.suggestedPrice = this.gasprecioService.removeDuplicateWeeks(data?.['suggested_price'] || []);
            } else {
              this.quotient = info['quotient'];
              this.diffSellingPrice = info['diff_sellling_price'];
              this.suggestedPrice = data?.['suggested_price'];
            }
            this.setData();
          }
        }, complete: () => {
          this.reqst = 2;
        }, error: () => {
          this.reqst = 3;
        }
      });
    } else {
      this.reqst = 2;
    }
  }

  setDataV2() {
    this.reqst = 1;
    const colorBlue = this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[3]);
    const colorOrange = this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[4]);
    const colorSuggested = this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[0]);

    const quotientData = this.fullData.map((day: any) => {
      const val = day.products?.[this.productType]?.quotient;
      return val == null ? null : +val;
    });

    const tarChartData: any = {
      name: 'Indice de Precios',
      data: quotientData,
      color: colorBlue,
      lineWidth: 2,
      marker: { radius: 4, symbol: 'triangle', lineColor: '#ffffff', lineWidth: 1 },
      yAxis: 1,
      tooltip: {
        pointFormatter: function () {
          return `<b>${this.series.name}: ${this.y?.toFixed(3)}</b>`;
        }
      },
    };

    const diffCompData = this.fullData.map((day: any) => {
      const val = day.products?.[this.productType]?.diff_ppc;
      return val == null ? null : +val;
    });

    const purchaseChartData: any = {
      name: 'Dif Precio vs Competencia',
      type: 'column',
      data: diffCompData,
      color: colorOrange,
      borderColor: colorOrange,
      borderWidth: quotientData.length >= 90 ? 0 : 2,
      yAxis: 0,
      tooltip: {
        pointFormatter: function () {
          return `<b>${this.series.name}: $ ${this.y?.toFixed(2)}</b>`;
        }
      },
    };

    const suggestedData = this.fullData.map((day: any) => {
      const val = day.products?.[this.productType]?.suggested_price;
      return val == null ? null : +val;
    });

    const suggestedPriceData: any = {
      name: 'Precio Sugerido',
      data: suggestedData,
      color: colorSuggested,
      lineWidth: 2,
      marker: { radius: 4, symbol: 'triangle', lineColor: '#0e469b', lineWidth: 1 },
      yAxis: 1,
      tooltip: {
        pointFormatter: function () {
          return `<b>${this.series.name}: ${this.y?.toFixed(3)}</b>`;
        }
      }
    };

    const lineXaxisLegendGenerator = {
      day: (v: any) => this.gasprecioService.parseDateDM(v.date.formatted),
      week: (v: any) => v.date.label,
      month: (v: any) => this.gasprecioService.parseDateM(v.date.formatted)
    };

    const lineXaxisLegend = this.fullData.map(
      lineXaxisLegendGenerator[this.period]
    );

    const xAxis = Array.isArray(this.chartOptions.xAxis) ? this.chartOptions.xAxis[0] : this.chartOptions.xAxis;
    xAxis.categories = lineXaxisLegend;

    this.chartOptions.series = [purchaseChartData, tarChartData];
    if (this.idGroup === '6697df2bfb7789085d7d82b4') this.chartOptions.series.push(suggestedPriceData);
    setTimeout(() => {
      this.reqst = 2;
    }, 100);
  }

  setData() {
    this.reqst = 1;
    const colorBlue = this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[3]);
    const colorOrange = this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[4]);
    const colorSuggested = this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[0]);
    const tarChartData: any = {
      name: 'Indice de Precios',
      data: this.quotient.map((v: any) => {
        if (v[this.productType] === null) {
          return null; // Devuelve null si el valor es null
        } else {
          return +v[this.productType]; // Devuelve el valor convertido a número
        }
      }),
      color: colorBlue,
      lineWidth: 2,
      marker: { radius: 4, symbol: 'triangle', lineColor: '#ffffff', lineWidth: 1 },
      yAxis: 1,
      tooltip: {
        pointFormatter: function () {
          return '<b>' + this.series.name + ': ' + this.y.toFixed(3) + '</b>';
        }
      },
    };

    const lineXaxisLegendGenerator = {
      day: (v: any) => this.gasprecioService.parseDateDM(v.date),
      week: (v: any) => v.date_alias,
      month: (v: any) => this.gasprecioService.parseDateM(v.date)
    };

    const lineXaxisLegend = this.quotient.map(lineXaxisLegendGenerator[this.period]);
    this.chartOptions['xAxis']['categories'] = lineXaxisLegend;
    const numberLabels = this.chartOptions['xAxis']['categories'].length;
    const borderW = numberLabels >= 90 ? 0 : 2;

    const purchaseChartData: any = {
      name: 'Dif Precio vs Competencia',
      type: 'column',
      data: this.diffSellingPrice.map((v: any) => {
        if (v[this.productType] === null) {
          return null; // Devuelve null si el valor es null
        } else {
          return +v[this.productType]; // Devuelve el valor convertido a número
        }
      }),
      color: colorOrange,
      borderColor: colorOrange,
      borderWidth: borderW,
      yAxis: 0,
      tooltip: {
        pointFormatter: function () {
          return '<b>' + this.series.name + ': $ ' + this.y.toFixed(2) + '</b>';
        }
      },
    };

    const suggestedPriceData: any = {
      name: 'Precio Sugerido',
      data: this.suggestedPrice?.map((v: any) => v[this.productType] === null ? null : +v[this.productType]),
      color: colorSuggested,
      lineWidth: 2,
      marker: { radius: 4, symbol: 'triangle', lineColor: '#0e469b', lineWidth: 1 },
      yAxis: 1,
      tooltip: {
        pointFormatter: function () {
          return '<b>' + this.series.name + ': ' + this.y.toFixed(3) + '</b>';
        }
      }
    };

    this.chartOptions.series = [purchaseChartData, tarChartData];
    if (this.idGroup === '6697df2bfb7789085d7d82b4') this.chartOptions.series.push(suggestedPriceData);
    setTimeout(() => {
      this.reqst = 2;
    }, 100);
  }

  generateImageChart() {
    const canvas5: any = document.getElementById('mychart5');
    const imgData5 = canvas5.toDataURL('image/png');
    this.sharedService.nextImgData5 = imgData5;
  }
}
